<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{ class?: HTMLAttributes['class'] }>();
</script>
<template>
  <span
    :class="
      cn(
        'ease absolute bottom-0 left-0 right-0 h-[2px] origin-bottom-right scale-x-0 transition-transform duration-500 group-hover:origin-bottom-left group-hover:scale-x-100 group-data-[is-refined=true]:scale-x-100 group-data-[state=open]:scale-x-100',
        props.class
      )
    "
  ></span>
</template>
